/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Not_EditableInputs */

const en_issue_not_editable = /** @type {(inputs: Issue_Not_EditableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the linesheet could no longer be changed when the file was read`)
};

/**
* | output |
* | --- |
* | "the linesheet could no longer be changed when the file was read" |
*
* @param {Issue_Not_EditableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_not_editable = /** @type {((inputs?: Issue_Not_EditableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Not_EditableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_not_editable(inputs)
});